import { NewsAO } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const archivedNewsAOReducer: RemoteReducer<NewsAO[]> =
  createRemoteReducer("archivedNewsAO")
